import { useState } from 'react';
import type { DocumentTypeDatabase } from '../../../../types';
import { useDeleteDocumentType } from '../../api/useDeleteDocumentType';
import { useGetDocumentTypes } from '../../api/useGetDocumentTypes';

export type Props = {
  spaceId: string;
  isAdmin: boolean;
};

export default function useDocumentTypesSettingsCard(props: Props) {
  const documentTypesQuery = useGetDocumentTypes(props.spaceId);
  const deleteType = useDeleteDocumentType();

  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [typeToEdit, setTypeToEdit] = useState<DocumentTypeDatabase | null>(null);
  const [typeToDelete, setTypeToDelete] = useState<DocumentTypeDatabase | null>(null);

  function handleOpenAdd() {
    setIsAddModalOpen(true);
  }

  function handleOpenEdit(type: DocumentTypeDatabase) {
    setTypeToEdit(type);
  }

  function handleCloseModal() {
    setIsAddModalOpen(false);
    setTypeToEdit(null);
  }

  function handleOpenDelete(type: DocumentTypeDatabase) {
    setTypeToDelete(type);
  }

  function handleCloseDelete() {
    setTypeToDelete(null);
  }

  // ConfirmDeleteDialog closes itself once the deletion succeeds and shows the error otherwise.
  function handleConfirmDelete() {
    if (!typeToDelete) return Promise.resolve();
    return deleteType.mutateAsync({ id: typeToDelete.id });
  }

  return {
    documentTypes: documentTypesQuery.data ?? [],
    isLoading: documentTypesQuery.isLoading,
    isError: documentTypesQuery.isError,
    isAddModalOpen,
    typeToEdit,
    typeToDelete,
    handleOpenAdd,
    handleOpenEdit,
    handleCloseModal,
    handleOpenDelete,
    handleCloseDelete,
    handleConfirmDelete,
  };
}
